<template>
    <form :style="{ height: '100%' }"
          novalidate
          @submit.prevent="onSubmit">
        <div class="modal-main">
            <h3>Choose fields to include in report</h3>
            <select-box v-if="showField"
                        label="Type"
                        :data-list="typeFields"
                        @selected="onTypeSelect">
            </select-box>
            <select-box v-if="!showField || form.typeReport === 'Rosters'"
                        label="Fields"
                        multipleSelect
                        :chip-width="chipWidth"
                        :data-list="reportFields"
                        :format-callback="report => report.second"
                        @selected="onFieldsNameSelect">
            </select-box>
            <div v-if="form.typeReport === 'Custom Forms'">
                <select-box label="Custom Form"
                            :data-list="filteredForms"
                            :placeholder="placeholderCustomFormSelect"
                            :format-callback="form => form.formName"
                            :disabled="!filteredForms.length"
                            @selected="onCustomFormSelect">
                </select-box>
            </div>
        </div>
        <div class="form-footer">
            <button class="primary-btn btn-center"
                    :disabled="disabledButton"
                    v-spinner="isLoading">
                Download
            </button>
        </div>
    </form>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {FormMixin} from '@/mixins/FormMixin';
    import {downloadFile} from '@/common/utils/files';
    import SpinnerDirective from '@/directives/SpinnerDirective';

    export default {
        name: 'BulkDownload',
        components: {
            SelectBox: () => import('@/components/controls/SelectBox'),
        },
        directives: { SpinnerDirective },
        mixins: [FormMixin],
        data() {
            return {
                typeFields: ['Rosters', 'Schedule', 'Custom Forms'],
                reportFields: [],
                filteredForms: [],
                form: {
                    nameOfFields: [],
                    typeReport: '',
                    formId: null
                },
            }
        },
        props: {
            getCallback: {
                type: Function,
                required: true
            },
            submitCallback: {
                type: Function,
                required: true
            },
            showField: {
                type: Boolean,
                required: false
            }
        },
        computed: {
            ...mapGetters(['classList', 'campList', 'aftercareList', 'schoolId', 'selected', 'selectedItemDropDown', 'isLoading', 'childrenList', 'isMobile', 'customForms']),

            chipWidth() {
                return window.innerWidth < 428 ? 185 : 135;
            },

            activitiesData() {
                return [
                    {name: 'My classes', type: 'Class', list: this.classList},
                    {name: 'My camps', type: 'Camp', list: this.campList},
                    {name: 'After Care', type: 'Aftercare', list: this.aftercareList}
                ];
            },

            activityType() {
                const item = this.activitiesData.find(el => el.name === this.$route.name);
                return item.type;
            },

            activityList() {
                const item = this.activitiesData.find(el => el.name === this.$route.name);
                return item.list;
            },

            placeholderCustomFormSelect() {
                if (!this.filteredForms.length) {
                    return 'No forms ...'
                }
            },

            disabledButton() {
                if (this.form.typeReport === 'Custom Forms' && !this.form.formId) {
                    return true;
                } else if (!this.formValid || this.formPristine) {
                    return true
                }
            }
        },
        watch: {
            'form.typeReport': {
                async handler(type) {
                    if (type && type === 'Schedule') {
                        this.form.nameOfFields = [];
                    }
                    if (type && type === 'Custom Forms') {
                        const formIdsList = [];
                        await this.getAllCustomForms();
                        const selectedActivities = this.activityList.filter(obj => this.selected.includes(obj.id));
                        selectedActivities.forEach(el => {
                            if (el.formIds.length) {
                                el.formIds.forEach(item => {
                                    if (!formIdsList.includes(item)) {
                                        formIdsList.push(item);
                                    }
                                })
                            }
                        })
                        this.filteredForms = this.customForms.filter(obj => formIdsList.includes(obj.id));
                    }
                },
                immediate: true
            },
        },
        methods: {
            ...mapActions([
                'resetSelectedItemFromSelectBox',
                'resetSelectedItems',
                'showSpinner',
                'hideSpinner',
                'getAllCustomForms',
                'getChildren'
            ]),

            async getXlsFileFieldsNames() {
                const { data } = await this.getCallback(this.schoolId);
                this.reportFields = data;
            },
            async onTypeSelect(type) {
                if (type) {
                    this.form.typeReport = type;
                }
            },
            onFieldsNameSelect(nameOfFields) {
                this.form.nameOfFields = nameOfFields
                    ? nameOfFields.map(nameOfField => nameOfField.first)
                    : this.selectedItemDropDown.map(nameOfField => nameOfField.first);
            },
            onCustomFormSelect(form) {
                if (form) {
                    this.form.formId = form.id;
                }
            },
            async onSubmit() {
                if (!this.isLoading) {
                    this.showSpinner();
                    let formWithIds = {};
                    if (this.form.typeReport === 'Custom Forms') {
                        formWithIds = {
                            activityIds: this.selected,
                            activityType: this.activityType,
                            formId: this.form.formId,
                            typeReport: this.form.typeReport
                        };
                    } else {
                        formWithIds = {
                            ids: this.selected,
                            nameOfFields: this.form.nameOfFields,
                            typeReport: this.form.typeReport
                        };
                    }
                    const { data } = await this.submitCallback(formWithIds);
                    this.resetSelectedItemFromSelectBox();
                    this.resetSelectedItems();
                    this.$emit('submit');
                    this.hideSpinner();
                    downloadFile(data);
                }
            }
        },
        created() {
            this.getXlsFileFieldsNames();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals/BulkDownload.vue